import React, { useEffect, useRef, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import Select from 'react-select';
import FileField from '../../../customControl/FileField';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { TravelAgentAddonInfoModel } from '../../../Models/TravelAgentModels';
import { getDateCombination } from '../../../components/commonClass/CommonFunctions';
import { alphaNumericspace, ApiNotRespondMessage, onlyAlphabets } from '../../../components/commonClass/CommonValidation';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import { travelAgentPropsAddOnInfo } from './TravelAgent.interface';
import { fileUpload, fileUploadModal } from '../../../components/commonClass/CommonInterfaceTypes';
import { AgentStatus } from '../../../_constants/agent.constant';


function TravelAgentAddOnInfo(props: travelAgentPropsAddOnInfo) {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, TravelAgentId, travelAgentOptionList, warnings, setWarningMessages, domainWiseDisable, statusId } = props;

  const defaultFileUpload = new fileUploadModal();
  const OnboardingMessage = "Onboarding of Travel Agent is Successful."

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [formValue, setFormValue] = useState(new TravelAgentAddonInfoModel());
  const [formError, setFormError] = useState<any>(null);
  const [RegistrationDocument, setRegistrationDocument] = useState<fileUpload>(defaultFileUpload);
  const [PANCertificate, setPANCertificate] = useState<fileUpload>(defaultFileUpload);
  const [SpecialAgreement, setSpecialAgreement] = useState<fileUpload>(defaultFileUpload);

  const [deleteRegistrationDocumentPath, setDeleteRegistrationDocumentPath] = useState<string>("");
  const [deletePANCertificatePath, setDeletePANCertificatePath] = useState<string>("");
  const [deleteSpecialAgreementPath, setDeleteSpecialAgreementPath] = useState<string>("");

  const [disabled, setDisabled] = useState(location?.state?.disabled ?? true);
  const [editDisabled, setEditDisabled] = useState(location?.state?.editdisabled ?? true);
  const [clearDisabled, setClearDisabled] = useState(true);

  const acceptance = ".pdf, .doc, .docx, image/*";
  const maxFileSize = 10;

  const RegistrationDocumentRef = useRef<HTMLInputElement>(null);
  const PANCertificateRef = useRef<HTMLInputElement>(null);
  const SpecialAgreementRef = useRef<HTMLInputElement>(null);

  const handleimageupload = async (pathdirectory: string, filename: string, file: any) => {
    await ImageUpload(pathdirectory, filename, file);
  };

  const handleimageDelete = async (filename: string) => {
    await ImageDelete(filename);
  };

  //#region API calling function
  const gettravelagentaddoninfobyid = async (id: number) => {
    const travelagentaddoninfobyid = await getAllData(`/midoffice/v1/gettravelagentaddoninfobyid?travelAgentId=${id}`)
    if (travelagentaddoninfobyid?.status && travelagentaddoninfobyid?.data) {
      setFormValue((form) => ({
        ...form,
        TravelAgentId: Number(id),
        LeadSourceMasterId: travelagentaddoninfobyid?.data?.[0]?.LeadSourceMasterId,
        LeadSourceOtherRemark: travelagentaddoninfobyid?.data?.[0]?.LeadSourceOtherRemark,
        Remarks: travelagentaddoninfobyid?.data?.[0]?.Remarks,
        AgencyRegistrationDocName: travelagentaddoninfobyid?.data?.[0]?.AgencyRegistrationDocName,
        AgencyRegistrationDocPath: travelagentaddoninfobyid?.data?.[0]?.AgencyRegistrationDocPath,
        PANDocName: travelagentaddoninfobyid?.data?.[0]?.PANDocName,
        PANDocPath: travelagentaddoninfobyid?.data?.[0]?.PANDocPath,
        SpecialAgreementDocName: travelagentaddoninfobyid?.data?.[0]?.SpecialAgreementDocName,
        SpecialAgreementDocPath: travelagentaddoninfobyid?.data?.[0]?.SpecialAgreementDocPath,
      }))

      const staticFilePath = "https://static-ethics.sgp1.digitaloceanspaces.com/etm/"
      setDeleteRegistrationDocumentPath(travelagentaddoninfobyid?.data?.[0]?.AgencyRegistrationDocPath ? `${staticFilePath}${travelagentaddoninfobyid?.data?.[0]?.AgencyRegistrationDocPath}` : "");
      setDeletePANCertificatePath(travelagentaddoninfobyid?.data?.[0]?.PANDocPath ? `${staticFilePath}${travelagentaddoninfobyid?.data?.[0]?.PANDocPath}` : "");
      setDeleteSpecialAgreementPath(travelagentaddoninfobyid?.data?.[0]?.SpecialAgreementDocPath ? `${staticFilePath}${travelagentaddoninfobyid?.data?.[0]?.SpecialAgreementDocPath}` : "");
    }
  }
  //#endregion

  //#region call API when get token
  useEffect(() => {
    async function fetchData(AgentId: number) {
      dispatch(loaderActions.start())
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        const user: any = GetLocalStorage();
        setFormValue((form) => ({ ...form, TravelAgentId: AgentId, UserId: user?.userMasterID ?? 0 }))
        setIsSaved((save: any) => ({ ...save, AddOnInfo: true }));
        Promise.allSettled([
          gettravelagentaddoninfobyid(AgentId)
        ])
        dispatch(loaderActions.end())
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }
    const TAid = Number(location?.state?.Id > 0 ? location?.state?.Id : TravelAgentId);
    TAid > 0 && fetchData(TAid);
  }, [location, TravelAgentId])
  //#endregion

  //#region call Save/Update function when click on "Yes" on tab change
  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      handleSaveUpdate();
    }
  }, [isConfirm])
  //#endregion

  //#region onChange functions
  const handleSelectChange = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    setFormError(null);
    setFormValue((form) => ({ ...form, [name]: e?.value, LeadSourceOtherRemark: "" }));
  }

  const handleOnChange = (name: string, value: any) => {
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }));
    setEditDisabled(false);
    setClearDisabled(false);
    setFormError(null);
    setFormValue((form) => ({ ...form, [name]: value }));
  }

  const isValidAddonFile = (type: string, name: string) => {
    if (type?.includes('image')) {
      return true;
    }
    else {
      return /\.(pdf|doc|docx)$/i.test(name)
    }
  }

  const handleFileUpload = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }));
    const file = e.target.files?.[0];
    const dateCombination = getDateCombination();
    const fileName = dateCombination + '_1_' + (file?.name?.replace(/ /g, "_"))?.replace(/-/g, '');
    const filePath = `MO/TravelAgentManagement/${name}/${fileName}`;
    const path = `MO/TravelAgentManagement/${name}/`;
    const fileSize = (file?.size / 1024) / 1024;
    const length = file?.type?.split('/')?.length
    // const fileType = file?.type?.split('/')?.[length - 1]?.toString()?.toLowerCase();
    const fileType = file?.type

    const fileData: fileUpload = {
      File: file ? file : null,
      FileName: file && isValidAddonFile(fileType, fileName) && fileSize < maxFileSize ? fileName : "",
      FilePath: file && isValidAddonFile(fileType, fileName) && fileSize < maxFileSize ? filePath : "",
      Path: file ? path : "",
      Size: file ? fileSize : 0,
      type: file ? fileType : "",
      needToUpload: file && isValidAddonFile(fileType, fileName) && fileSize < maxFileSize ? true : false
    }
    setEditDisabled(file ? false : editDisabled);
    setClearDisabled(file ? false : clearDisabled);

    if (name === "RegistrationDocument") {
      setRegistrationDocument(fileData);
      setFormValue((form) => ({
        ...form,
        AgencyRegistrationDocName: fileData?.FileName,
        AgencyRegistrationDocPath: fileData?.FilePath,
      }))
    }
    else if (name === "PANCertificate") {
      setPANCertificate(fileData);
      setFormValue((form) => ({
        ...form,
        PANDocName: fileData?.FileName,
        PANDocPath: fileData?.FilePath,
      }))
    }
    else if (name === "SpecialAgreement") {
      setSpecialAgreement(fileData);
      setFormValue((form) => ({
        ...form,
        SpecialAgreementDocName: fileData?.FileName,
        SpecialAgreementDocPath: fileData?.FilePath,
      }))
    }

  }
  //#endregion

  const validateData = () => {
    setWarningMessages([]);
    let status: boolean = true;
    const error: any = {}
    if (formValue?.LeadSourceOtherRemark?.trim()?.length === 0 && formValue.LeadSourceMasterId === 1) {
      error.LeadSourceOtherRemark = "Please provide details for Lead Source Remark";
      status = false;
    }
    // const WarningAssignment = warnings?.Assignment?.warningValidation()
    // if (selectedTabId === tabId && WarningAssignment) {
    //   setWarningMessages((prev: any) => ([...prev, WarningAssignment]))
    //   status = false;
    // }
    setFormError(error);
    return status;
  }

  //#region insert / update data function
  const handleSaveUpdate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validateData()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        formValue.TravelAgentId = Number(formValue.TravelAgentId)
        const insertupdatetravelagentaddontnfo = await postUsersData('/midoffice/v1/insertupdatetravelagentaddontnfo', formValue);
        if (insertupdatetravelagentaddontnfo?.status) {
          setIsSaved((save: any) => ({ ...save, AddOnInfo: true }));
          setIsRedirect(true);

          Promise.allSettled([
            formValue?.AgencyRegistrationDocName === "" && deleteRegistrationDocumentPath !== "" && await handleimageDelete(deleteRegistrationDocumentPath),
            formValue?.PANDocName === "" && deletePANCertificatePath !== "" && await handleimageDelete(deletePANCertificatePath),
            formValue?.SpecialAgreementDocName === "" && deleteSpecialAgreementPath !== "" && await handleimageDelete(deleteSpecialAgreementPath),
          ])

          if (RegistrationDocument?.needToUpload && isValidAddonFile(RegistrationDocument?.type, RegistrationDocument?.FileName)) {
            Promise.allSettled([
              deleteRegistrationDocumentPath !== "" && await handleimageDelete(deleteRegistrationDocumentPath),
              await handleimageupload(RegistrationDocument?.Path, RegistrationDocument?.FileName, RegistrationDocument?.File)
            ])
          }
          if (PANCertificate?.needToUpload && isValidAddonFile(PANCertificate?.type, PANCertificate?.FileName)) {
            Promise.allSettled([
              deletePANCertificatePath !== "" && await handleimageDelete(deletePANCertificatePath),
              await handleimageupload(PANCertificate?.Path, PANCertificate?.FileName, PANCertificate?.File)
            ])
          }
          if (SpecialAgreement?.needToUpload && isValidAddonFile(SpecialAgreement?.type, SpecialAgreement?.FileName)) {
            Promise.allSettled([
              deleteSpecialAgreementPath !== "" && await handleimageDelete(deleteSpecialAgreementPath),
              await handleimageupload(SpecialAgreement?.Path, SpecialAgreement?.FileName, SpecialAgreement?.File)
            ])
          }

          dispatch({ type: 'ALERTINGMESSAGE', message: OnboardingMessage, path: '/travel-agent-management' });
        }
        else {
          dispatch({ type: 'ALERTING', message: insertupdatetravelagentaddontnfo?.message || ApiNotRespondMessage });
        }
        dispatch(loaderActions.end());
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }
  }
  //#endregion

  //#region clear function
  const handleClear = () => {
    setFormError(null);
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }));
    setFormValue((form) => ({
      ...form,
      LeadSourceMasterId: 0,
      LeadSourceOtherRemark: "",
      Remarks: "",
      AgencyRegistrationDocName: "",
      AgencyRegistrationDocPath: "",
      PANDocName: "",
      PANDocPath: "",
      SpecialAgreementDocName: "",
      SpecialAgreementDocPath: "",
    }));
    setRegistrationDocument(defaultFileUpload);
    setPANCertificate(defaultFileUpload);
    setSpecialAgreement(defaultFileUpload);

    if (RegistrationDocumentRef.current !== null) {
      RegistrationDocumentRef.current.value = ""
    }
    if (PANCertificateRef.current !== null) {
      PANCertificateRef.current.value = ""
    }
    if (SpecialAgreementRef.current !== null) {
      SpecialAgreementRef.current.value = ""
    }
  }
  //#endregion

  //#region back function
  const handleBack = () => {
    navigate('/travel-agent-management');
  }
  //#endregion


  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Lead Source'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={travelAgentOptionList?.leadSourceList}
          value={travelAgentOptionList?.leadSourceList?.filter((fil) => fil?.value === formValue.LeadSourceMasterId)}
          onChange={(e: any) => handleSelectChange('LeadSourceMasterId', e)}
          isSearchable
          isClearable
          isDisabled={disabled || domainWiseDisable?.isExternalUser}
        />
      </ColumnsDevider>

      <ColumnsDevider label=''><div></div></ColumnsDevider>

      <div className='col-md-3 col-12 pb-2'></div>
      <div className='col-md-7 col-12 pb-2'>
        <input
          type='text'
          className='form-control mb-lg-1'
          name="LeadSourceOtherRemark"
          id="LeadSourceOtherRemark"
          placeholder='Other Text'
          value={formValue.LeadSourceOtherRemark}
          onChange={(e: any) => {
            e.target.value?.length <= 100 &&
              handleOnChange(e.target.name, onlyAlphabets(e.target.value))
          }}
          maxLength={100}
          disabled={disabled || domainWiseDisable?.isExternalUser || formValue.LeadSourceMasterId !== 1}
        />
        {formError?.LeadSourceOtherRemark && <div className='text-danger text-start fs_14'>{formError?.LeadSourceOtherRemark}</div>}
      </div>

      <div className='col-md-3 col-12'> Remarks </div>
      <div className='col-md-7 col-12'>
        <textarea
          className='form-control'
          name="Remarks"
          id="Remarks"
          rows={10}
          placeholder='Remarks'
          value={formValue.Remarks}
          onChange={(e: any) => {
            e.target.value?.length <= 200 &&
              handleOnChange(e.target.name, alphaNumericspace(e.target.value))
          }}
          maxLength={200}
          disabled={disabled || domainWiseDisable?.isExternalUser}
        />
      </div>

      <div className='mb-2'><h4 className='fw-bold'>Attachments</h4></div>

      <div className='col-md-6 col-12 my-2'>
        <label htmlFor="RegistrationDocument" className="col-form-label">Agency Registration Document</label>
      </div>
      <div className='col-md-4 col-12 my-2'>
        <FileField
          ref={RegistrationDocumentRef}
          id="RegistrationDocument"
          accept={acceptance}
          onChange={(e: any) => handleFileUpload("RegistrationDocument", e)}
          disabled={disabled || domainWiseDisable?.isExternalUser}
        />
        {formValue?.AgencyRegistrationDocName && <div className='fs_14 text-truncate'> {formValue?.AgencyRegistrationDocName} </div>}
        {/* <button type="button" className="btn btn-primary mx-1 px-3 w-auto">Add</button> */}
      </div>

      <div className='col-md-6 col-12 my-2'>
        <label htmlFor="PANCertificate" className="col-form-label">PAN Card/TIN Certificate</label>
      </div>
      <div className='col-md-4 col-12 my-2'>
        <FileField
          ref={PANCertificateRef}
          id="PANCertificate"
          accept={acceptance}
          onChange={(e: any) => handleFileUpload("PANCertificate", e)}
          disabled={disabled || domainWiseDisable?.isExternalUser}
        />
        {formValue?.PANDocName && <div className='fs_14 text-truncate'> {formValue?.PANDocName} </div>}
        {/* <button type="button" className="btn btn-primary mx-1 px-3 w-auto">Add</button> */}
      </div>

      <div className='col-md-6 col-12 my-2'>
        <label htmlFor="SpecialAgreement" className="col-form-label">Special Agreement</label>
      </div>
      <div className='col-md-4 col-12 my-2'>
        <FileField
          ref={SpecialAgreementRef}
          id="SpecialAgreement"
          accept={acceptance}
          onChange={(e: any) => handleFileUpload("SpecialAgreement", e)}
          disabled={disabled || domainWiseDisable?.isExternalUser}
        />
        {formValue?.SpecialAgreementDocName && <div className='fs_14 text-truncate'> {formValue?.SpecialAgreementDocName} </div>}
        {/* <button type="button" className="btn btn-primary mx-1 px-3 w-auto">Add</button> */}
      </div>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnAdd" onClick={handleSaveUpdate} disabled={editDisabled || disabled || domainWiseDisable?.isExternalUser} >
          {domainWiseDisable?.loginUserDomainMasterId !== 1 ? (statusId === AgentStatus.Rejected ? "Re-Submit" : "Submit") : (location?.state?.type === "Edit" ? "Update" : "Finish")}
        </button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnClear" onClick={handleClear} disabled={clearDisabled || disabled || domainWiseDisable?.isExternalUser} >Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" id="btnBack" onClick={handleBack}  >Back</button>
      </div>

    </div>
  )
}

export default TravelAgentAddOnInfo